import React from "react";
import "./AdvancedLoadingScreen.css";

const AdvancedLoadingScreen = ({ message = "Loading, please wait..." }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <i className="fas fa-circle-notch spinner-icon" />
        <p>{message}</p>
      </div>
    </div>
  );
};

export default AdvancedLoadingScreen;
